import React from "react";
import { useTranslation } from "react-i18next";
import {
  UiButton,
  UiGradiantOutlinedBtn,
} from "../../../../_uiComponents/common/UiButton";
import { UiHorizontalButtonGroup } from "../../../../_uiComponents/common/UiHorizontalButtonGroup";

export const ForgotPasswordLeavePopup = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div
        className={
          props?.className ? props?.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props?.message}
        </h3>
        {props?.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            className="df-red-gradiant-outlined-btn"
            onClick={props?.buttonOnClickClose}
            name={t("Cancel")}
          />
          <UiButton
            onClick={props?.buttonOnClick}
            className="df-ui-dark-bg-btn"
            name={props?.buttonText? t(props?.buttonText) : t("Ok")}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};
